import { render, staticRenderFns } from "./TablesClient.vue?vue&type=template&id=8f5acf04"
import script from "./TablesClient.vue?vue&type=script&lang=js"
export * from "./TablesClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports